import React, { useEffect, useRef } from "react"
import Typography from "@mui/material/Typography"
import { Box, Dialog } from "@mui/material";
import { useOrderStore } from "../store/order";
import { useImagePreloader } from "../hooks/useImagePreloader";
import { logger } from "../utils/logger";

// import unavailable from '../assets/images/unavailable.svg';
// import soldout from '../assets/images/soldout.svg';
// import added from '../assets/images/added.svg';
// import ontheway from '../assets/images/ontheway.svg';
// import empty from '../assets/images/empty.svg';
// import confirm from '../assets/images/confirm.svg';
// import history from '../assets/images/history.svg';
// import clock from '../assets/images/clock.svg';
// import checklist from '../assets/images/checklist.svg';

// const LazyPicture = styled(LazyLoadImage)`
//   object-fit: contain;
//   width: ${({ width }) => (width ? `${width}rem` : "100%")};
//   height: ${({ width }) => (width ? `${width}rem` : "100%")};

//   &.lazy-load-image-background.opacity {
//     background-image: none !important;
//     opacity: 0;
//     transition: opacity 0.3s;
//   }

//   &.lazy-load-image-background.opacity.lazy-load-image-loaded {
//     opacity: 1;
//   }
// `;

// 이미지 URL을 상수로 분리하여 한 번만 생성
const ICON_URLS = [
  `${process.env.PUBLIC_URL}/assets/images/checklist.svg`,
  `${process.env.PUBLIC_URL}/assets/images/unavailable.svg`,
  `${process.env.PUBLIC_URL}/assets/images/soldout.svg`,
  `${process.env.PUBLIC_URL}/assets/images/added.svg`,
  `${process.env.PUBLIC_URL}/assets/images/ontheway.svg`,
  `${process.env.PUBLIC_URL}/assets/images/empty.svg`,
  `${process.env.PUBLIC_URL}/assets/images/confirm.svg`,
  `${process.env.PUBLIC_URL}/assets/images/history.svg`,
  `${process.env.PUBLIC_URL}/assets/images/clock.svg`,
  `${process.env.PUBLIC_URL}/assets/images/limit-time.svg`,
  `${process.env.PUBLIC_URL}/assets/images/limit-count.svg`,
  `${process.env.PUBLIC_URL}/assets/images/limit-count.svg`,
  `${process.env.PUBLIC_URL}/assets/images/limit-count.svg`,
  `${process.env.PUBLIC_URL}/assets/images/limit-count.svg`,
  `${process.env.PUBLIC_URL}/assets/images/added.svg`,
  `${process.env.PUBLIC_URL}/assets/images/checklist.svg`
];

const SnackDialog = (props: { mode: any; showSnack: any; setShowSnack: any; closeDialog: any; value?: number}) => {
  const { value, mode, showSnack, closeDialog} = props;
  const { setOpenCart } = useOrderStore()
  const timerRef = useRef<NodeJS.Timeout>();

  // 이미지 미리 로드 (한 번만 실행되고 캐시됨)
  useImagePreloader(ICON_URLS, {
    onLoad: () => logger.debug('SnackDialog images preloaded'),
    onError: (error) => logger.error('Failed to preload SnackDialog images:', error)
  });

  const texts = [
    `Please,\ncheck required modifier`, 
    `This item is unavailable\nfor ordering now.`, 
    `This item is sold out.`, 
    `Added to your cart!`, 
    `On the way!\nPlease wait a few minutes.`, 
    `Your cart is empty.\nAdd items to order!`, 
    `Confirming your order.`, 
    `No order history.\nPlease place an order.`,
    `Please wait`,
    `Please wait ${value} minute(s) between orders in this category.`, 
    `You can order \n up to ${value} of this category.`, 
    `You can order \n up to ${value} of this item.`,
    `You can order up to \n ${value} of this item per table.`,
    `You can order \n at least ${value} of this item.`,
    `Added to your cart!`,
    `Please choose at least ${value} options.`
  ];

  useEffect(()=> {
    logger.debug('snack', mode)
    if(!showSnack) return

    // Clear any existing timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      closeDialog()
      logger.debug('timeout')
      // 카트는 자동으로 닫지 않음 - 사용자가 직접 닫도록 함
    }, 1200);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      logger.debug('exit')
    }
  },[showSnack])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  // const close = () => {
  //   closeDialog()
  // }

  return (
    <Dialog open={showSnack} onClose={closeDialog} PaperProps={{ sx :{justifyContent: 'center', alignItems: 'center', width: '63.9rem', height: '33.8rem', overflow: 'hidden', borderRadius: '1.5rem' } }}>
      <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '5.0rem 9.0rem', gap: '2.8rem', alignItems: 'center'}}>
        <img src={ICON_URLS[mode]} alt="img" style={{ width: '8.0rem', height: '8.0rem', alignSelf: 'center'}}/>
        {mode === 14 ? 
          <Box sx={{mt: '28px', maxHeight: '18.0rem', width: '50.0rem',}}>
            <Typography sx={{padding: '1.0rem 4.8rem', textAlign: 'center', borderRadius: '1.5rem', backgroundColor: '#F72E13', fontSize: '30px', fontWeight: '600', fontStyle: 'normal' , 
              letterSpacing: '-.044', color: '#fff', textWrap: 'nowrap'}}>Recommended item</Typography> 
            <Typography sx={{fontSize: '30px', fontWeight: '600', fontStyle: 'normal',  textAlign: 'center'}}>{texts[mode]}</Typography> 
          </Box> :
          <Typography component="p" sx={{fontSize: '3.4rem', fontWeight: '600', fontStyle: 'normal',  maxHeight: '18.0rem', width: '50.0rem', textAlign: 'center', 
            lineHeight: '150%', letterSpacing: '-.044', whiteSpace: 'pre-line'}}>{texts[mode]}</Typography> 
        }
      </Box>
    </Dialog>
  )
}

export default SnackDialog
